import { useState, useMemo } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import '../../../styles/range.css';

const { Range: RcRange } = Slider;

const handleStyle = {
  width: '1.5rem',
  height: '1.5rem',
  marginTop: '-10px',
  border: '0',
  backgroundColor: '#54B8C8',
};
const trackStyle = {
  backgroundColor: '#54B8C8',
};

export default function Range({
  id,
  name,
  attrs,
  label,
  setVariablesState,
  initialState,
  reverse = false,
}) {
  const initialMin = +attrs.min;
  const initialMax = +attrs.max;

  const [range, setRange] = useState(() => {
    if (typeof setVariablesState === 'function') {
      if (initialState) {
        setVariablesState(initialState, { loadingInitialState: true });
        return [initialState.min, initialState.max];
      }
      setVariablesState({ min: initialMin, max: initialMax });
    }
    return [initialMin, initialMax];
  });

  const min = useMemo(() => range[0], [range]);
  const max = useMemo(() => range[1], [range]);

  function handleChange(value) {
    setRange(value);
  }

  function handleAfterChange(value) {
    if (typeof setVariablesState === 'function') {
      setVariablesState({ min: value[0], max: value[1] });
    }
  }

  // reverse puts the high end on the left (ATAD-146 model scores, where
  // 1 = best). Only the display flips: the range is still reported as min/max.
  const minInput = (
    <input
      type="number"
      value={min}
      min={initialMin}
      max={max}
      onChange={(e) => {
        const val = parseInt(e.target.value);
        if (!isNaN(val)) {
          setRange([val, max]);
        }
      }}
      onBlur={() => {
        const [newMin, newMax] = [
          Math.max(initialMin, Math.min(initialMax, min)),
          Math.max(initialMin, Math.min(initialMax, max)),
        ].sort((a, b) => a - b);
        setRange([newMin, newMax]);
        handleAfterChange([newMin, newMax]);
      }}
      className="hide-arrows py-1 px-1 rounded-lg bg-gray-200 text-gray-700 w-36 text-center focus:outline-none focus:ring-1 focus:ring-cyan-500"
    />
  );
  const maxInput = (
    <input
      type="number"
      value={max}
      min={min}
      max={initialMax}
      onChange={(e) => {
        const val = parseInt(e.target.value);
        if (!isNaN(val)) {
          setRange([min, val]);
        }
      }}
      onBlur={() => {
        const [newMin, newMax] = [
          Math.max(initialMin, Math.min(initialMax, min)),
          Math.max(initialMin, Math.min(initialMax, max)),
        ].sort((a, b) => a - b);
        setRange([newMin, newMax]);
        handleAfterChange([newMin, newMax]);
      }}
      className="hide-arrows py-1 px-1 rounded-lg bg-gray-200 text-gray-700 w-36 text-center focus:outline-none focus:ring-1 focus:ring-cyan-500"
    />
  );

  return (
    <div className="flex flex-col flex-grow w-full border-l-2 border-gray-400 pl-2 mb-2">
      <div className="flex justify-between items-center mb-1">
        <span>{name}</span>
        <div className="flex items-center gap-1 ml-2">
          {reverse ? maxInput : minInput}
          <span className="text-gray-400">-</span>
          {reverse ? minInput : maxInput}
        </div>
      </div>
      <div className="py-2 px-2">
        <RcRange
          defaultValue={range}
          min={initialMin}
          max={initialMax}
          allowCross={true}
          reverse={reverse}
          value={range}
          onChange={handleChange}
          onAfterChange={handleAfterChange}
          trackStyle={[trackStyle, trackStyle]}
          handleStyle={[handleStyle, handleStyle]}
          railStyle={{ backgroundColor: '#E5E7EB' }}
        />
      </div>
      <div className="flex justify-between text-gray-500">
        <span>{reverse ? initialMax : initialMin}</span>
        {label && <span className="px-2 whitespace-nowrap">{label}</span>}
        <span>{reverse ? initialMin : initialMax}</span>
      </div>
    </div>
  );
}
